module.exports = __webpack_public_path__ + "static/media/survey-response-rate-icon.579464f5.svg";